"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../../../hooks");
const reusables_1 = require("../../../../comps/reusables");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const useFeatureSettingsMutation_1 = require("./useFeatureSettingsMutation");
exports.UserDetailAdminSettings = ({ user: { id, fullName, email, featureFlagOverrides }, }) => {
    const displayName = fullName || email;
    const { currentUser } = hooks_1.useOsmosysContext();
    const isCurrentUser = currentUser.id === id;
    const { mutate, mutationResult } = hooks_1.useLoginAs(id);
    const { featureFlags, setFeatureFlags, stickiedSuccess, featureFlagsSaveResult, } = useFeatureSettingsMutation_1.useFeatureSettingsMutation(id, featureFlagOverrides);
    return (react_1.default.createElement(react_2.OsmosysSmallContainer, null,
        !isCurrentUser && (react_1.default.createElement(react_2.OsmosysDiv, { className: "text-center mb-2" },
            react_1.default.createElement(react_2.OsmosysButton, { osysName: "UserDetailAdminSettings", color: isCurrentUser ? 'link' : 'danger', confirm: true, mutate: mutate, mutationResult: mutationResult, disabled: isCurrentUser },
                "Login as ",
                displayName))),
        react_1.default.createElement(react_2.OsmosysDiv, null,
            react_1.default.createElement("h2", null,
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: featureFlagsSaveResult.loading
                        ? pro_solid_svg_icons_1.faSpinner
                        : stickiedSuccess
                            ? pro_solid_svg_icons_1.faCheckCircle
                            : pro_solid_svg_icons_1.faFlag, fixedWidth: true, spin: featureFlagsSaveResult.loading }),
                ' ',
                "Feature flags"),
            react_1.default.createElement(react_2.OsmosysErrorAlert, { apolloError: featureFlagsSaveResult.error, resource: "User", action: "update" }),
            react_1.default.createElement(reusables_1.FeatureFlagsForm, { featureFlagOverrides: featureFlags, onChange: setFeatureFlags }))));
};
exports.default = exports.UserDetailAdminSettings;
//# sourceMappingURL=index.js.map